<script>
  const user = {}
  export default {
    user
  }
</script>



// WEBPACK FOOTER //
// src/components/common/Common.vue